import React from "react";
import ModalBase from "./ModalBase";
import DocService from "../export/DocService";

import '../../../assets/sass/components/modals/download-report-modal.scss';
import DownloadFile from "../report/DownloadFile";
import Receipt from "../report/Receipt";

/**
 * Download receipt modal.
 */
class DownloadReceiptModal extends ModalBase {
    /**
     * Renders modal content within the body of the modal.
     * @returns {React.ReactNode} The modal content.
     */

    renderBody = () => {
        return (
            <DownloadFile
                files={this.props.files}
                renderFile={Receipt}
            />
        );
    };

    renderFooter = () => undefined;
    exportedFileName = () => 'receipt';

    static defaultProps = {
        headerTitle: "Download Receipt"
    };

    /**
     * Returns default size of modal.
     * @returns {string} The modal size.
     */
    defaultSize = () => "sm";

    modalClassname = () => "download-report-modal";
}

export default DownloadReceiptModal;
